import React from "react"
import { Avatar as AvatarAntd } from "antd"

const Avatar = ({ size }) => <AvatarAntd size={size} icon="user" />

export default Avatar